<template>
    <city-selector
        :areaData="areaData"
        :isshowHeader="false"
        :selectCompleted.sync="selectCompleted"
        :selectedProvince.sync="selectedProvince"
        :selectedCity.sync="selectedCity"
        :selectedCountry.sync="selectedCountry"
        :selectedAreaType.sync="selectedAreaType"
    />
</template>

<script>
import CitySelector from './index'
import mixCitySelector from './mixin'
import { mapMutations, mapGetters } from 'vuex'
import { LOCATION_CODE_MAP, COUNTRY_CODE } from '@uip-alpha/business-constants'

export default {
    components: {
        'city-selector': CitySelector
    },
    props: {
        updateSelect: {
            type: Function
        },
        updateAreaCode: {
            type: Function
        },
        updateArea: {
            type: Function,
            default: () => ({})
        },
        area: {
            type: Object,
            default: () => ({})
        },
        page: {
            type: String,
            default: ''
        },
        isDest: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectCompleted: false
        }
    },
    created() {
        let areaData = {}
        if (
            this.area.province &&
            !this.isIntl(this.area.province.rateCode) &&
            [LOCATION_CODE_MAP.HK, LOCATION_CODE_MAP.MAC, LOCATION_CODE_MAP.TW].every(item => item !== this.area.province.rateCode)
        ) {
            areaData = this.isDest ? this.getAreaDataDest : this.getAreaData
        }
        const { province, city, country } = areaData
        if (province && city && country) {
            this.initCitySelector({
                code: COUNTRY_CODE.MAINLAND,
                province: (province || {}).name,
                city: (city || {}).name,
                country: (country || {}).name
            })
            this.selectedAreaType = 'country'
        } else {
            this.initCitySelector({
                code: COUNTRY_CODE.MAINLAND
            })
            this.selectedAreaType = 'province'
        }
    },

    methods: {
        ...mapMutations('range', {
            setAreaData: 'setAreaData',
            setAreaDataDest: 'setAreaDataDest'
        }),
        init() {
            this[this.isDest ? 'setAreaDataDest' : 'setAreaData']({
                province: this.selectedProvince,
                city: this.selectedCity,
                country: this.selectedCountry
            })
            this.updateArea({
                province: this.selectedProvince,
                city: this.selectedCity,
                country: this.selectedCountry
            })
            const code = this.selectedCountry.code
            const rateCode = this.selectedCountry.rateCode
            const countryCode = this.selectedCountry.countryCode || COUNTRY_CODE.MAINLAND
            let areaName = [this.selectedProvince.name, this.selectedCity.name, this.selectedCountry.name].filter(item => !!item).join('-')
            if (areaName.endsWith('-')) {
                areaName = areaName.slice(0, -1)
            }
            code && this.updateAreaCode({ code, areaName, rateCode, countryCode })
        },
        isIntl(rateCode) {
            const pattern = new RegExp('[A-Za-z]+')
            return pattern.test(rateCode)
        }
    },
    computed: {
        ...mapGetters('range', {
            getAreaData: 'getAreaData',
            getAreaDataDest: 'getAreaDataDest'
        })
    },
    watch: {
        selectCompleted(val) {
            this.updateSelect(val)
            this.init()
        },
        selectedCountry(val) {
            this.init()
        }
    },
    mixins: [mixCitySelector]
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/citySelector/area-inland.vue